import React from 'react';
import { clsx } from 'clsx';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
}

export function Input({ label, error, icon, className, ...props }: InputProps) {
  return (
    <div className="space-y-2">
      {label && (
        <label className="flex items-center gap-2 text-sm font-medium text-slate-300">
          <span className="w-1 h-1 rounded-full bg-purple-500" />
          {label}
        </label>
      )}
      <div className="relative group">
        {icon && (
          <div className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500 group-focus-within:text-cyan-400 transition-colors">
            {icon}
          </div>
        )}
        <input
          className={clsx(
            'w-full bg-slate-900/80 backdrop-blur-sm rounded-xl',
            'border border-slate-700/50 text-white',
            'placeholder:text-slate-500 font-mono text-sm',
            'transition-all duration-300',
            'focus:outline-none focus:border-cyan-500/50 focus:ring-2 focus:ring-cyan-500/20',
            'focus:bg-slate-900',
            'hover:border-slate-600',
            icon ? 'pl-12 pr-4 py-3.5' : 'px-4 py-3.5',
            error && 'border-red-500/50 focus:border-red-500 focus:ring-red-500/20',
            className
          )}
          {...props}
        />
        {/* Focus glow effect */}
        <div className="absolute inset-0 rounded-xl opacity-0 group-focus-within:opacity-100 transition-opacity pointer-events-none">
          <div className="absolute inset-0 rounded-xl bg-gradient-to-r from-cyan-500/10 via-purple-500/10 to-pink-500/10 blur-xl" />
        </div>
      </div>
      {error && (
        <p className="flex items-center gap-2 text-sm text-red-400">
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          {error}
        </p>
      )}
    </div>
  );
}
